import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { initI18n } from './i18n';
import { configureZodI18n } from './i18n/zod-i18n';
import { initObservability } from './lib/observability';
import './styles/globals.css';

initI18n();
configureZodI18n();

/*
  🔴 A T0.10 escreveu `initObservability` e a T0.14 ligou-lhe o gate de consentimento — mas
  **nada o chamava**. O SDK do Sentry nem sequer era dependência do app, logo o módulo era código
  correto, testado e inerte: nenhum erro de produção seria alguma vez reportado.

  É o terceiro caso do mesmo padrão nesta fatia e na anterior (o `pnpm lint` da T0.15, o Tailwind
  do bloco 3): configuração escrita, testada, e nunca executada. Testes de unidade com dependência
  injetada provam a lógica, não a ligação — e a ligação é o que faltava nos três.

  A ordem importa: antes de `createRoot`, para que uma falha durante a montagem seja capturada.

  O PostHog não participa deste bootstrap. A T0.19 carrega o SDK dinamicamente no controller global,
  somente depois de o Cookiebot confirmar consentimento de estatísticas.
*/
initObservability({
  iniciarSentry: (opcoes) => Sentry.init(opcoes),
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Elemento raiz #root não encontrado.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
